// -- React Libraries
import React from 'react';

// -- Components
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import TabBar from 'rc-tabs/lib/TabBar';

import GridAppName from "../GridAppName/index";
import GridDescription from "../GridDescription/index";
import GridGraphics from "../GridGraphics/index";
import GridRating from "../GridRating/index";

// -- Styles
import 'rc-tabs/assets/index.css';
import StyleWrapper from "./Wrapper";

export default class ScoreSummaryTabs extends React.Component {
    constructor(props) {
        super(props);

        this.appNameAnalyze = props.analyzes.appName;
        this.appDescriptionAnalyze = props.analyzes.appDescription;
        this.appGraphicsAnalyze = props.analyzes.appGraphics;
        this.appRatingsAndReviewsAnalyze = props.analyzes.appRatingsAndReviews;

        this.state = { };
    }

    componentDidMount() {
        setTimeout(function(){
            this.setState({opacity: 1});
        }.bind(this), 1);
    }

    render() {
        return (
            <StyleWrapper style={{opacity: this.state.opacity || 0}}>
                <Tabs
                    className="tabs"
                    // onChange={callback}
                    renderTabBar={()=><TabBar/>}
                    renderTabContent={()=><TabContent />}
                >
                    <TabPane tab='应用名称' key="1">
                        <GridAppName
                            // appName={this.props.app.trackName}
                            // isFormatOK={true}
                            // isBrandingOK={true}
                            // isLengthOK={true}
                            // brandingLength={15}
                            // lengthLength={30}
                            // data={this.props.data}
                            data={this.appNameAnalyze}
                        />
                    </TabPane>

                    <TabPane tab='描述' key="2">
                        <GridDescription
                            // appDescription={this.props.app.description}
                            // isLengthOK={true}
                            // isSpellCheckOK={true}
                            // lengthLength={this.props.app.description.length}
                            // data={this.props.data}
                            data={this.appDescriptionAnalyze}
                        />
                    </TabPane>

                    <TabPane tab='图像' key="3">
                        <GridGraphics
                            // screenshotUrls={this.props.app.screenshotUrls}
                            // isQuantityOK={true}
                            // isShapeOK={false}
                            // isPreviewVideoOK={false}
                            // data={this.props.data}
                            data={this.appGraphicsAnalyze}
                        />
                    </TabPane>

                    <TabPane tab='评分及评论' key="4">
                        <GridRating
                            // appId={this.props.app.trackId}
                            // country={this.props.country}
                            // appAverageUserRating={this.props.app.averageUserRating}
                            // appUserRatingCount={this.props.app.userRatingCount}
                            // data={this.props.data}
                            data={this.appRatingsAndReviewsAnalyze}
                        />
                    </TabPane>
                </Tabs>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/Tabs/index.js